import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CurCtx = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(localStorage.getItem("sl_currency") || "INR");
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/billing/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  const setCurrency = (c) => {
    localStorage.setItem("sl_currency", c);
    setCurrencyState(c);
  };

  return <CurCtx.Provider value={{ currency, setCurrency, config }}>{children}</CurCtx.Provider>;
}

export const useCurrency = () => useContext(CurCtx);
